module.exports = __webpack_public_path__ + "img/partner19.f58d747a.png";